import React, { useState } from 'react';
import { KeyframeMarker } from './KeyframeMarker';
import type { KeyframeLineProps } from '../types';
import { isBackgroundAsset } from '@/pages/editor/components/timeline/TimelineCategoryItem/assetCapabilities';

export const KeyframeLine: React.FC<KeyframeLineProps> = ({
  assetInstanceId,
  assetStartTime,
  assetDuration,
  assetCategory,
  scale,
  isLocked,
  isVisible,
  keyframes = [],
  onKeyframeMove,
  onKeyframeMoveEnd,
  onKeyframeSelect,
  isKeyframeEditMode = false,
  isCurrentAssetInEditMode = false,
  selectedKeyframeId,
  isPlaying = false
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`relative w-full h-full transition-colors ${
        isKeyframeEditMode && isCurrentAssetInEditMode 
          ? 'cursor-crosshair bg-lureo-brand-ink/5'
          : isKeyframeEditMode 
            ? 'cursor-not-allowed bg-lureo-neutral/20' 
            : isHovered && !isLocked 
              ? 'cursor-pointer bg-lureo-hover' 
              : 'cursor-pointer bg-transparent'
      }`}
      data-keyframe-line
      data-asset-id={assetInstanceId}
      style={{
        pointerEvents: 'none',
      }}
      onMouseEnter={(e) => {
        e.stopPropagation();
        if (!isKeyframeEditMode || isCurrentAssetInEditMode) {
          setIsHovered(true);
        }
      }}
      onMouseLeave={(e) => {
        e.stopPropagation();
        setIsHovered(false);
      }}
    >
      {/* Connecting line is now rendered in TimelineCategoryItem for proper z-index control */}

      {/* Keyframe markers - only show if there's more than 1 keyframe (more than just the default start keyframe) */}
      {/* Don't render markers for background assets */}
      {keyframes.length > 1 && !isBackgroundAsset(assetCategory || '') && (() => {
        // Sort keyframes by time position to find the last one
        const sortedKeyframes = [...keyframes].sort((a, b) => a.timePosition - b.timePosition);
        // Find the last keyframe (excluding start marker)
        const nonStartKeyframes = sortedKeyframes.filter(kf => kf.category !== 'start');
        const lastKeyframeId = nonStartKeyframes.length > 0 
          ? nonStartKeyframes[nonStartKeyframes.length - 1].id 
          : null;
        
        return keyframes.map((keyframe) => {
          const isSelected = selectedKeyframeId === keyframe.id;
          const isLastKeyframe = keyframe.id === lastKeyframeId && keyframe.category !== 'start';
          return (
            <KeyframeMarker
              key={keyframe.id}
              keyframe={keyframe}
              assetStartTime={assetStartTime}
              assetDuration={assetDuration}
              scale={scale}
              isLocked={isLocked}
              isVisible={isVisible}
              onMove={onKeyframeMove}
              onMoveEnd={onKeyframeMoveEnd} 
              onSelect={onKeyframeSelect}
              isSelected={isSelected}
              assetInstanceId={assetInstanceId}
              isPlaying={isPlaying}
              isLastKeyframe={isLastKeyframe}
            />
          );
        });
      })()}
    </div>
  );
};